import { InfoListItem } from '@moreharvest/component-library';
import { FormattedMessage } from '@utils/i18n';

interface Props {
    i18nId: string;
    value: string | number;
}

const BasicListField = ({ i18nId, value }: Props) => {
    return (
        <InfoListItem.WithDivider>
            <span className="Body-Medium">
                <FormattedMessage id={i18nId} />
            </span>
            <strong className="Body-Medium font-semibold">{value}</strong>
        </InfoListItem.WithDivider>
    );
};

export default BasicListField;
